import RichText from '@commons/components/RichText';
import Text from '@commons/components/Text';
import BaseContainer from '@commons/containers/BaseContainer';
import { generateId } from '@commons/helpers/string';
import type { DrupalBlock, DrupalParagraph } from '@commons/types/drupal';

// Type definition for an insight section properties.

export type InsightSection = DrupalParagraph & {
  title: string;
  content: string;
};

/**
 * InsightsSections field block.
 *
 * The `content-wrapper` ID is used to track the scroll for the progress bar.
 */

export const InsightSectionsBlock = ({ content }: DrupalBlock<InsightSection[]>) => {
  const sections = Array.isArray(content) ? content : [];

  const renderedSections = sections.map(({ title, content }) => {
    const id = generateId(title);

    return (
      <BaseContainer id={id} marginTop="xl" key={id}>
        <Text as="h2" level="h4" transform="uppercase">
          {title}
        </Text>
        <RichText value={content} />
      </BaseContainer>
    );
  });

  return <BaseContainer id="content-wrapper">{renderedSections}</BaseContainer>;
};

export default InsightSectionsBlock;
